import { jsxs as t, jsx as o } from "react/jsx-runtime";
const i = ({
  width: r,
  height: n,
  className: e
}) => /* @__PURE__ */ t(
  "svg",
  {
    className: e,
    fill: "none",
    height: n,
    viewBox: "0 0 20 20",
    width: r,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          d: "M10.1152 12.5589V10.9255C10.1152 8.82553 11.8152 7.11719 13.9236 7.11719H15.5569",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M4.68164 7.125H6.31499C8.41499 7.125 10.1233 8.82499 10.1233 10.9333V11.475V14.375",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M5.94921 5.625L4.44922 7.125L5.94921 8.62501",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M14.0488 5.625L15.5488 7.125L14.0488 8.62501",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M7.49935 18.3327H12.4993C16.666 18.3327 18.3327 16.666 18.3327 12.4993V7.49935C18.3327 3.33268 16.666 1.66602 12.4993 1.66602H7.49935C3.33268 1.66602 1.66602 3.33268 1.66602 7.49935V12.4993C1.66602 16.666 3.33268 18.3327 7.49935 18.3327Z",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);
export {
  i as Content
};
